import {BillingConfig} from 'main/content/sales/billing/billingConfig';
import {InvoiceConfig} from 'main/content/sales/invoice/invoiceConfigs';
import { ReceiptConfig } from './receipt/receiptConfig';
import { BrokerConfig } from './broker/brokerConfig';
import { DeliveryNoteConfig } from './deliveryNote/DeliveryNoteConfig';
import { DeliveryNoteViewConfig } from './deliveryNoteView/DeliveryNoteViewConfig';

export const salesConfigs = [
    BillingConfig,
    InvoiceConfig,
    ReceiptConfig,
    BrokerConfig,
    DeliveryNoteConfig,
    DeliveryNoteViewConfig
];


// WEBPACK FOOTER //
// ./src/main/content/sales/salesConfigs.js